import { render } from "./ContactUsSuccess.vue?vue&type=template&id=ecfcbb86"
import script from "./ContactUsSuccess.vue?vue&type=script&lang=js"
export * from "./ContactUsSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/builds/websites/koch-bus-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__